import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../app/api';
import { fetchModelAssociationsPayload, fetchGetAfslAndPracticeDetailsForAdviserPayload, 
         ModelAssociations, ModelAfslAndPracticeDetailsForAdviser } from './types';

export enum ModelAssociationsActionTypes {
  FetchModelAssociations = '@@model/details/FetchModelDetails',
  FetchGetAfslAndPracticeDetailsForAdviser = '@@model/details/FetchGetAfslAndPracticeDetailsForAdviser',
  DownloadModelAssociation = '@@model/details/DownloadModelAssociation',
  FetchAfslAndModelAssociations = '@@model/details/FetchAfslAndModelAssociations',
}

export enum ModelAssociationsApiEndpoints {
  fetchModelAssociations = '/bff/GetModelExposure',
  fetchGetAfslAndPracticeDetailsForAdviser = '/customers/GetAfslAndPracticeDetailsForAdviser'
}

export const fetchModelAssociations = createAsyncThunk(
  ModelAssociationsActionTypes.FetchModelAssociations,
  async (wrapper: fetchModelAssociationsPayload) => {

    const response = await api.get<ModelAssociations>(
      `${ModelAssociationsApiEndpoints.fetchModelAssociations}?modelVersionId=${wrapper.modelVersionId}` +
        (wrapper.afslId ? `&afslId=${wrapper.afslId}` : "")
    );
    return response.data;
  }
);

export const fetchAfslAndModelAssociations = createAsyncThunk(
  ModelAssociationsActionTypes.FetchAfslAndModelAssociations,
  async (wrapper: fetchGetAfslAndPracticeDetailsForAdviserPayload, { dispatch }) => {

    const response = await api.get<ModelAfslAndPracticeDetailsForAdviser>(
      `${ModelAssociationsApiEndpoints.fetchGetAfslAndPracticeDetailsForAdviser}?adviserId=${wrapper.modelAdviserId}`
    );

    const afslId = response.data.afslId;
    if (wrapper.modelVersionId !== null) {
      await dispatch(
        fetchModelAssociations({
          modelVersionId: wrapper.modelVersionId,
          afslId
        })
      ).unwrap();
    }
    return afslId;
  }
);